import { render, staticRenderFns } from "./AppNavigationFavoritesItem.vue?vue&type=template&id=a9099f2e&scoped=true"
import script from "./AppNavigationFavoritesItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationFavoritesItem.vue?vue&type=script&lang=js"
import style0 from "./AppNavigationFavoritesItem.vue?vue&type=style&index=0&id=a9099f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9099f2e",
  null
  
)

export default component.exports